/* eslint-disable no-unused-vars */
export enum userRoles {
  SuperAdmin = 'Superadmin',
  Admin = 'Admin',
  User = 'User',
  DataOps = 'DataOps',
  CustomerSupport = 'Customer Support',
}
